import { render } from "./SabhaAdmins.vue?vue&type=template&id=5a31e23e&scoped=true"
import script from "./SabhaAdmins.vue?vue&type=script&lang=js"
export * from "./SabhaAdmins.vue?vue&type=script&lang=js"

import "./SabhaAdmins.vue?vue&type=style&index=0&id=5a31e23e&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a31e23e"]])

export default __exports__